import { render, staticRenderFns } from "./NavigationBackButton.vue?vue&type=template&id=9810ac50"
import script from "./NavigationBackButton.vue?vue&type=script&lang=js"
export * from "./NavigationBackButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports